/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */
window.loadDateObj = new Date();
window.startLoadTimestamp = window.loadDateObj.getTime();

define('main',['require','jqueryMigrate','modernizr','markdown','core/router','xml2json','jqrotate','touchpunch','rotatecss','spritely','consolePF','jquery.joyride','fastclick','jquery','backbone','core/engine','core/lms-connect','json!config/config.json'],function(require) {
  'use strict';

  //////////////
  // IMPORTS //{
  //////////////
  require.onError = function(err) {
    console.error('Require Error:', err);
    Engine.radio.trigger('check.connection');
  };

  require('jqueryMigrate');
  require('modernizr');
  require('markdown');
  require('core/router');
  require('xml2json');
  require('jqrotate');
  require('touchpunch');
  require('rotatecss');
  require('spritely');
  require('consolePF');
  require('jquery.joyride');

  var FastClick = require('fastclick');

  var $ = require('jquery');
  var Backbone = require('backbone');
  //require('backbone-super');

  var Engine = require('core/engine');
  var LMSConnect = require('core/lms-connect');
  var Settings = require('json!config/config.json');

  /*****************************************************************************************************************///}

  $(document).on('click', 'a[href^="#"]:not([data-bypass])', function(e)
  {
    e.preventDefault();

    var href = $(this).attr('href');
    Backbone.history.navigate(href, true);
    return false;
  });

  window.app = Engine;

  FastClick.attach(document.body);

  LMSConnect.on('ready', function()
  {
    Engine.start(Settings);
  });

  // attempt LMS connection
  LMSConnect.connect(Settings);
});

